import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Inbox, FileText, Users, BookOpen, Mail } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ submissions: 0, articles: 0, members: 0, issues: 0, emails: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [subs, arts, members, issues, emails] = await Promise.all([
          api.get("/admin/submissions"),
          api.get("/admin/articles"),
          api.get("/editorial-board"),
          api.get("/admin/issues"),
          api.get("/admin/email-logs"),
        ]);
        setStats({
          submissions: subs.data.length,
          articles: arts.data.length,
          members: members.data.length,
          issues: issues.data.length,
          emails: emails.data.length,
        });
      } catch {}
    })();
  }, []);

  const cards = [
    { label: "Submissions", value: stats.submissions, icon: Inbox, to: "/admin/submissions", color: "#2BA6A6" },
    { label: "Articles", value: stats.articles, icon: FileText, to: "/admin/articles", color: "#001F3F" },
    { label: "Issues", value: stats.issues, icon: BookOpen, to: "/admin/issues", color: "#2BA6A6" },
    { label: "Editorial Board", value: stats.members, icon: Users, to: "/admin/editorial-board", color: "#001F3F" },
    { label: "Email Queue", value: stats.emails, icon: Mail, to: "/admin/emails", color: "#2BA6A6" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-serif text-3xl text-[#001F3F]">Editorial Dashboard</h1>
      <div className="w-10 h-[2px] bg-[#2BA6A6] mt-3 mb-8"></div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} className="bg-white border border-gray-200 p-6 hover:border-[#2BA6A6] transition-colors" data-testid={`stat-${c.label.toLowerCase().replace(/ /g, "-")}`}>
            <c.icon className="w-5 h-5" style={{ color: c.color }} />
            <div className="font-serif text-3xl text-[#001F3F] mt-3">{c.value}</div>
            <div className="text-xs font-sans uppercase tracking-wider text-gray-500 mt-1">{c.label}</div>
          </Link>
        ))}
      </div>

      <div className="mt-12 bg-white border border-gray-200 p-6">
        <h2 className="font-serif text-xl text-[#001F3F] mb-1">Quick Start</h2>
        <div className="w-8 h-[2px] bg-[#2BA6A6] mb-4"></div>
        <ul className="space-y-3 text-sm font-sans text-[#001F3F]/85">
          <li>• Review and manage incoming submissions in <Link to="/admin/submissions" className="text-[#2BA6A6] hover:underline">Submissions</Link>.</li>
          <li>• Create published articles and generate official PDFs in <Link to="/admin/articles" className="text-[#2BA6A6] hover:underline">Articles</Link>.</li>
          <li>• Use the <Link to="/admin/pdf-generator" className="text-[#2BA6A6] hover:underline">Official PDF Generator</Link> to format any article into the journal style.</li>
          <li>• Maintain volumes and issues in <Link to="/admin/issues" className="text-[#2BA6A6] hover:underline">Issues</Link>.</li>
          <li>• Update site content in <Link to="/admin/content" className="text-[#2BA6A6] hover:underline">Content (CMS)</Link>.</li>
        </ul>
      </div>
    </div>
  );
}
